module.exports = __webpack_public_path__ + "5831d189c3ccb2ec5ab0c5024f6f1684.ttf";